import React from 'react';
import Navbar  from '../components/common/Navbar';
import Footer  from '../components/common/Footer';
import './ServicesPage.css';


const SERVICES = [
  {
    id: 'past',
    name: 'Past Prediction',
    tagline: 'Validate events that shaped your life',
    desc: 'Our most popular service. Share your birth details and Tilak will map key events from your past — career shifts, health events, relationship milestones — through your Vedic birth chart. If we name 3 past events accurately, you can trust the future predictions completely.',
    highlights: ['Birth chart analysis', 'Dasha & transit mapping', 'Key past events identified', 'Telugu, Hindi or English'],
    badge: 'Most Popular',
    msg: 'Hi, I am interested in a Past Prediction session.',
    icon: <PastIcon />,
  },
  {
    id: 'future',
    name: 'Future Consultation',
    tagline: 'A roadmap for the years ahead',
    desc: 'A comprehensive future reading covering career prospects, relationship timelines, financial cycles, health watch periods and major life turning points. Delivered with a detailed dasha analysis so you know not just what will happen, but when.',
    highlights: ['Career & business forecast', 'Marriage & relationship timing', 'Financial cycles analysis', 'Health watch periods', 'Detailed dasha roadmap'],
    msg: 'Hi, I would like a Future Consultation.',
    icon: <FutureIcon />,
  },
  {
    id: 'tarot',
    name: 'Tarot Reading',
    tagline: 'Clarity through symbolic insight',
    desc: 'Intuitive tarot readings for questions about love, career, finances and decisions. Each card spread is interpreted through both traditional tarot wisdom and Vedic astrological context for deeper accuracy.',
    highlights: ['Love & relationship spreads', 'Career decision guidance', 'Yes/No question clarity', 'Full 10-card Celtic Cross'],
    msg: 'Hi, I am interested in a Tarot Reading.',
    icon: <TarotIcon />,
  },
  {
    id: 'palmistry',
    name: 'Palmistry Reading',
    tagline: 'Your destiny written in your hand',
    desc: 'Submit a clear photo of your palm and our expert reads the major and minor lines for insights into personality, life span indicators, career direction, marriage prospects and hidden health patterns.',
    highlights: ['Life line analysis', 'Heart & head line reading', 'Fate line interpretation', 'Personality & health insights'],
    msg: 'Hi, I am interested in a Palmistry Reading.',
    icon: <PalmIcon />,
  },
  {
    id: 'numerology',
    name: 'Numerology Reading',
    tagline: 'The power hidden in your numbers',
    desc: 'Your name, birth date and birth number carry powerful vibrational energy. This reading analyses your life path number, lucky years, favourable directions, name compatibility and the best timing for major decisions.',
    highlights: ['Life path number analysis', 'Lucky years & periods', 'Name compatibility check', 'Business name guidance'],
    msg: 'Hi, I would like a Numerology Reading.',
    icon: <NumIcon />,
  },
  {
    id: 'vastu',
    name: 'Online Vastu',
    tagline: 'Align your space with cosmic energy',
    desc: 'Share your home or office floor plan and photos. Our Vastu expert identifies energy blockages, identifies the right directions for important rooms, and provides practical, cost-effective remedies without major construction.',
    highlights: ['Home & office floor plan analysis', 'Direction corrections', 'Practical low-cost remedies', 'Before & after energy assessment'],
    msg: 'Hi, I need a Vastu Consultation.',
    icon: <VastuIcon />,
  },
  {
    id: 'remedies',
    name: 'Remedies by Tilak',
    tagline: 'Personal remedies crafted by the founder',
    desc: 'Unlike generic gemstone or mantra suggestions, every remedy here is personally designed by Tilak for your exact planetary configuration. This includes mantra recommendations, gemstone selection, ritual timing, dietary guidance and charitable acts.',
    highlights: ['Personal mantra selection', 'Gemstone prescription', 'Ritual timing guidance', 'Dietary & lifestyle adjustments', 'Personally crafted by Tilak'],
    badge: 'By Founder',
    msg: 'Hi, I would like to know about Tilak\'s Remedies.',
    icon: <RemedyIcon />,
  },
];

const ServicesPage = () => (
  <div className="svc-page">
    <Navbar />
    <main>
      {/* Hero */}
      <section className="svc-page__hero">
        <div className="svc-page__hero-inner">
          <p className="section-eyebrow">VTD Astrology</p>
          <h1 className="svc-page__hero-title">Our Services</h1>
          <p className="svc-page__hero-sub">
            Authentic Vedic wisdom across 7 specialised services —
            enquire on our chat for pricing and availability.
          </p>
          <div className="gold-divider" style={{ maxWidth: 300, margin: '1.5rem auto 0' }} />
        </div>
      </section>

      {/* Service cards */}
      <section className="svc-page__list">
        <div className="svc-page__list-inner">
          {SERVICES.map((s, i) => (
            <article key={s.id} className={`svc-detail${i % 2 === 1 ? ' svc-detail--reverse' : ''}`}>
              <div className="svc-detail__visual">
                <div className="svc-detail__icon-wrap">{s.icon}</div>
              </div>
              <div className="svc-detail__body">
                {s.badge && <span className="svc-detail__badge">{s.badge}</span>}
                <h2 className="svc-detail__name">{s.name}</h2>
                <p className="svc-detail__tagline">{s.tagline}</p>
                <p className="svc-detail__desc">{s.desc}</p>
                <ul className="svc-detail__highlights">
                  {s.highlights.map((h) => (
                    <li key={h}><span className="svc-detail__check">✦</span>{h}</li>
                  ))}
                </ul>
                <a href="/chat" className="svc-detail__btn">
                  Chat with Tilak Now →
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Admin Access Section */}
      <section className="svc-page__admin">
        <div className="svc-page__admin-inner">
          <div className="admin-access">
            <div className="admin-access__icon">
              <AdminIcon />
            </div>
            <h3 className="admin-access__title">Admin Access</h3>
            <p className="admin-access__desc">Manage reviews and community content</p>
            <a href="/admin" className="admin-access__btn">
              Admin Panel →
            </a>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

function PastIcon()   { return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><circle cx="40" cy="40" r="30"/><path d="M40 22v18l12 7"/><path d="M20 40 A20 20 0 0 1 40 20" stroke="#FFD700" strokeWidth="1.8" strokeDasharray="6 4"/></svg>; }
function FutureIcon() { return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><path d="M12 66 Q40 12 68 66"/><circle cx="40" cy="34" r="6" fill="#FFD700" stroke="none"/><path d="M40 40 L40 62" strokeDasharray="4 4"/></svg>; }
function TarotIcon()  { return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><rect x="22" y="8" width="36" height="64" rx="5"/><circle cx="40" cy="34" r="10" stroke="#FFD700" strokeWidth="1.8"/><line x1="28" y1="58" x2="52" y2="58"/><line x1="32" y1="64" x2="48" y2="64" opacity="0.5"/></svg>; }
function PalmIcon()   { return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><path d="M28 64 Q24 42 26 28 Q26 16 34 16 Q38 16 38 28 L38 42 Q38 16 44 16 Q50 16 50 28 L50 42 Q50 16 56 18 Q64 20 60 34 L56 54 Q64 44 68 50 Q72 60 60 66 Q46 72 36 66 Z"/></svg>; }
function NumIcon()    { return <svg viewBox="0 0 80 80" width="72" height="72"><text x="8" y="38" fontSize="22" fill="#D4AF37" fontFamily="Georgia">108</text><text x="8" y="64" fontSize="24" fill="#FFD700" fontFamily="Georgia" opacity="0.7">∞</text><circle cx="62" cy="20" r="14" stroke="#D4AF37" strokeWidth="2" fill="none"/><text x="56" y="26" fontSize="16" fill="#FFD700" fontFamily="Georgia">7</text></svg>; }
function VastuIcon()  { return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><rect x="14" y="14" width="52" height="52"/><line x1="14" y1="40" x2="66" y2="40" opacity="0.4"/><line x1="40" y1="14" x2="40" y2="66" opacity="0.4"/><circle cx="40" cy="40" r="9" stroke="#FFD700" strokeWidth="1.8"/><line x1="40" y1="14" x2="40" y2="4" stroke="#FFD700" strokeWidth="2.5"/></svg>; }
function RemedyIcon() { return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><path d="M40 8 L46 28 L68 28 L50 42 L56 64 L40 50 L24 64 L30 42 L12 28 L34 28 Z"/><circle cx="40" cy="40" r="7" fill="#FFD700" opacity="0.7" stroke="none"/></svg>; }
function AdminIcon()  { return <svg viewBox="0 0 48 48" width="32" height="32" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><rect x="6" y="10" width="36" height="28" rx="3"/><path d="M12 6 C12 6 18 2 24 2 C30 2 36 6 36 6"/><line x1="16" y1="18" x2="32" y2="18"/><line x1="16" y1="22" x2="28" y2="22"/><line x1="16" y1="26" x2="30" y2="26"/><circle cx="38" cy="38" r="6" fill="#FFD700" stroke="none"/><path d="M36 36 L38 38 L42 34" stroke="#000" strokeWidth="1.5"/></svg>; }

export default ServicesPage;
